const { default: endOfDayHistory } = await import(`./V2/endOfDayHistory.json`, { with: { type: 'json' } });
const { default: streamingMarketData } = await import(`./V2/streamingMarketData.json`, { with: { type: 'json' } });
const { default: intradayHistory } = await import(`./V2/intradayHistory.json`, { with: { type: 'json' } });
const { default: intradaySnapshot } = await import(`./V2/intradaySnapshot.json`, { with: { type: 'json' } });
const { default: entityBase } = await import(`./V2/entityBase.json`, { with: { type: 'json' } });
const { default: marketBase } = await import(`./V2/marketBase.json`, { with: { type: 'json' } });
const { default: listingBase } = await import(`./V2/listingBase.json`, { with: { type: 'json' } });
const { default: instrumentBase } = await import(`./V2/instrumentBase.json`, { with: { type: 'json' } });
const { default: instrumentSymbology } = await import(`./V2/instrumentSymbology.json`, { with: { type: 'json' } });
const { default: listingSymbology } = await import(`./V2/listingSymbology.json`, { with: { type: 'json' } });
const { default: freeTextSearch } = await import(`./V2/freeTextSearch.json`, { with: { type: 'json' } });
const { default: criteriaSearch } = await import(`./V2/criteriaSearch.json`, { with: { type: 'json' } });
const { default: endOfDaySnapshot } = await import(`./V2/endOfDaySnapshot.json`, { with: { type: 'json' } });
const { default: instrumentMarkets } = await import(`./V2/instrumentMarkets.json`, { with: { type: 'json' } });
const { default: streamingIntradayTradesWithHistory } = await import(`./V2/streamingIntradayTradesWithHistory.json`, { with: { type: 'json' } });
const { default: fundamentals } = await import(`./V2/fundamentals.json`, { with: { type: 'json' } });
const { default: estimates } = await import(`./V2/estimates.json`, { with: { type: 'json' } });
const { default: indexComposition } = await import(`./V2/indexComposition.json`, { with: { type: 'json' } });
const { default: entityClassification } = await import(`./V2/entityClassification.json`, { with: { type: 'json' } });
const { default: instrumentClassification } = await import(`./V2/instrumentClassification.json`, { with: { type: 'json' } });
const { default: swissStampDuty } = await import(`./V2/swissStampDuty.json`, { with: { type: 'json' } });
const { default: instrumentDetail } = await import(`./V2/instrumentDetail.json`, { with: { type: 'json' } });
const { default: marketHolidays } = await import(`./V2/marketHolidays.json`, { with: { type: 'json' } });
const { default: mifidIISuitability } = await import(`./V2/mifidIISuitability.json`, { with: { type: 'json' } });
const { default: mifidIICostAndCharges } = await import(`./V2/mifidIICostAndCharges.json`, { with: { type: 'json' } });
const { default: issueCondition } = await import(`./V2/issueCondition.json`, { with: { type: 'json' } });

export const apisv2 = {
    endOfDayHistory,
    streamingMarketData,
    intradayHistory,
    intradaySnapshot,
    entityBase,
    marketBase,
    listingBase,
    instrumentBase,
    instrumentSymbology,
    listingSymbology,
    freeTextSearch,
    criteriaSearch,
    endOfDaySnapshot,
    instrumentMarkets,
    streamingIntradayTradesWithHistory,
    estimates,
    fundamentals,
    indexComposition,
    entityClassification,
    instrumentClassification,
    swissStampDuty,
    instrumentDetail,
    marketHolidays,
    issueCondition,
    mifidIISuitability,
    mifidIICostAndCharges
}
